<template>
  <div class="card-modal">
    <h3 class="title --small">{{ $store.state.app.card.title }}</h3>
    <RawHtml :html="$store.state.app.card.description" class="card-modal__content"/>
  </div>
</template>

<script>
import {RawHtml} from '@/components/global'

export default {
  name: 'ContentCardModal',
  components: {RawHtml}
}
</script>